export const LMS_POPSTATE = 'LMS_POPSTATE';